import React from "react";
import { Box, Typography } from "@mui/material";

/**
 * A single titled section inside a legal document.
 * The `id` is used as the anchor target for the page table of contents.
 */
const LegalSection = ({ id, title, children }) => {
  return (
    <Box
      component="section"
      id={id}
      sx={{ scrollMarginTop: "96px", mb: 3 }}
    >
      <Typography
        variant="h6"
        component="h2"
        sx={{ fontWeight: 700, mt: 3, mb: 1, color: "#23576B" }}
      >
        {title}
      </Typography>
      {children}
    </Box>
  );
};

export default LegalSection;
